import React from 'react'
import {Button, Media} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import {MdDelete, MdEdit, MdEmail, MdVisibility} from 'react-icons/md';

function duration(session) {
    if (session && session.session_started_at && session.session_closed_at) {
     return dateHelpers.timeDifference(new Date(session.session_started_at), new Date(session.session_closed_at))
    }
    else return ""
}

export class TsessionReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            session: props.session,
        };

    }

    render() {
        return (
            <tr>
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.session && this.state.session.name ? this.state.session.name.substring(0, 30) : "..."}
                    </span>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {dateHelpers.stringTime(this.state.session.session_started_at)}
                    </span>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {this.state.session.session_closed_at ? dateHelpers.stringTime(this.state.session.session_closed_at) : "-"}
                    </span>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {duration(this.state.session)}
                    </span>
                </td>

                <td className="text-right align-content-end">
                    {/*<Button className="btn-icon" color="secondary"*/}
                    {/*        onClick={e => this.props.onInvoiceSelected(e, this.state.invoice)}>*/}
                    {/*    <MdVisibility/>*/}
                    {/*</Button>*/}

                    {/*<Button className="btn-icon" color="secondary"*/}
                    {/*        onClick={e => this.props.editInvoice(e, this.state.invoice)}>*/}
                    {/*    <MdEdit/>*/}
                    {/*</Button>*/}

                    {/*<Button className="btn-icon" color="info"*/}
                    {/*        onClick={e => this.props.sendInvoice(e, this.state.invoice)}>*/}
                    {/*    <MdEmail/>*/}
                    {/*</Button>*/}

                    <Button className="btn-icon" color="warning"
                            onClick={e => this.props.deleteSession(e, this.state.session)}>
                        <MdDelete/>
                    </Button>
                </td>
            </tr>
        )
    }

}

